/* ==========================================================================
   CLARITY HEALTH CO — SCIENCE BAND accordion
   Single-open accordion: opening one item closes the others; clicking the open
   item closes it. Keeps aria-expanded (trigger) and aria-hidden (panel) in sync.
   Native <button> triggers, so keyboard/focus work for free. Lightweight, no deps.
   ========================================================================== */
(function () {
  function wire(section) {
    if (!section || section.dataset.sciWired === '1') return;
    var items = Array.prototype.slice.call(section.querySelectorAll('.clarity-sci__item'));
    if (!items.length) return;
    section.dataset.sciWired = '1';

    function setOpen(item, open) {
      var trigger = item.querySelector('.clarity-sci__trigger');
      var panel = item.querySelector('.clarity-sci__panel');
      item.classList.toggle('is-open', open);
      if (trigger) trigger.setAttribute('aria-expanded', String(open));
      if (panel) panel.setAttribute('aria-hidden', String(!open));
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('.clarity-sci__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (other) { setOpen(other, false); });
        if (!isOpen) setOpen(item, true);   // clicking the open one leaves all closed
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-clarity-sci]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-wire when the Theme Editor re-renders this section.
  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target || document;
    var section = target.querySelector ? target.querySelector('[data-clarity-sci]') : null;
    if (section) wire(section);
  });
})();
